module.exports = __webpack_public_path__ + "ClientApp/images/content/Dr.Dani.png";